import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  OrderSummary,
} from '@savgroup-front-common/types';

// eslint-disable-next-line max-len
const ENDPOINT = `${APIConfiguration.owner}owners/${COMMON_QUERY_PARAMS.OWNER_ID}/products/${COMMON_QUERY_PARAMS.OWNER_PRODUCT_ID}/full`;

export interface GetProductFullInformationsPayload {
  ownerId: string;
  productId: string;
}

export const getProductFullInformationsRequest = (
  payload: GetProductFullInformationsPayload,
): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.OWNER_ID, payload.ownerId).replace(
    COMMON_QUERY_PARAMS.OWNER_PRODUCT_ID,
    payload.productId,
  ),
  config: { method: SUPPORTED_METHODS.GET },
});

const getProductFullInformations = async (
  payload: GetProductFullInformationsPayload,
): Promise<BackResponse<OrderSummary> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<OrderSummary>>(
      getProductFullInformationsRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default getProductFullInformations;
